import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      id: 0,
      email: '',
      permissions: {},
      name: '',
      type: ''
    }
  },
  actions: {
    logoutUser ({ commit }) {
      commit('setUser', {});
    }
  },
  mutations: {
    setUserID (state, id) {
      Vue.set(state.user, 'id', parseInt(id, 10));
    },
    setUserEmail (state, email) {
      Vue.set(state.user, 'email', email);
    },
    setUserName (state, name) {
      Vue.set(state.user, 'name', name);
    },
    setUserType (state, type) {
      Vue.set(state.user, 'type', type);
    },
    setUserPermissions (state, permissions) {
      Vue.set(state.user, 'permissions', permissions);
    }
  },
  getters: {
    getUserID: (state) => state.user.id,
    getUserEmail: (state) => state.user.email,
    getUserType: (state) => state.user.type,
    getUserName: (state) => state.user.name,
    getUserPermissions: (state) => state.user.permissions
  }
});
